module.exports = __webpack_public_path__ + "assets/in.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/in.svg
// module id = 1184
// module chunks = 7